import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import common_zh from "./translations/zh-CN/common.json";
import common_en from "./translations/en/common.json";
import common_fr from "./translations/fr/common.json";
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    returnEmptyString: false,
    debug: true,
    fallbackLng: ['en','zh','fr'],
    forceTranslationFallback: true,
    lng: 'en',
    resources: {
      en: {
        translation: common_en              // 'common' is our custom namespace
      },
      zh: {
        translation: common_zh
      },
        fr: {
            translation: common_fr
        },

    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });

export default i18n;